import React, {useRef} from 'react';
import {Link} from "react-router-dom";

import {useAuth} from '../helpers/authContext.js'
import {useLogin} from '../helpers/loginContext.js'

import Login from '../pages/Login/index.js'
import Register from '../pages/Register/index.js'

interface PageHeaderProps {
    props?: unknown;
}

interface PageHeaderElemProps {
    props?: unknown;
}

export default function PageHeader({props}: PageHeaderProps) {

	return (
		<>
            <PageHeaderElem props={props}/>
		</>
	)
} 

function PageHeaderElem({props}: PageHeaderElemProps) {
    var hideUnused: boolean = true;

    const {currentUser, setUser} = useAuth(); 
    const {setLoginType} = useLogin();

    const productsSubmenu = useRef<HTMLLIElement>(null);

    function handleSubmenuLinkClick(e: React.MouseEvent): void {

        // react override native onclick so the menu component never receive the message ... here we tweak their styles
        setTimeout(()=>{
            productsSubmenu.current?.classList.remove('opened');
            productsSubmenu.current?.classList.remove('focus');
        },
        100)
    }
    function handleLogout(e: React.MouseEvent): void {
        fetch( `/user/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: undefined
        }).then(( result ) => {
            return result.json();
        }).then(( data ) => {
            setUser(false);
        }).catch(( e ) => {
            // TODO: add global flash message to the  template
            // console.error( "Exception", e );
            // setFlashProps({error_msg: "Unknown error"})   ;     
        });
    }

    return (
        <header className="section page-header">
        <div className="rd-navbar-wrap">
            <nav 
                className="rd-navbar rd-navbar-classic" 
                data-layout="rd-navbar-fixed" 
                data-sm-layout="rd-navbar-fixed" 
                data-md-layout="rd-navbar-fixed" 
                data-md-device-layout="rd-navbar-fixed"
                data-lg-layout="rd-navbar-fixed" 
                data-lg-device-layout="rd-navbar-fixed" 
                data-xl-layout="rd-navbar-static" 
                data-xl-device-layout="rd-navbar-static" 
                data-xxl-layout="rd-navbar-static" 
                data-xxl-device-layout="rd-navbar-static" 
                data-lg-stick-up-offset="0px" 
                data-xl-stick-up-offset="0px" 
                data-xxl-stick-up-offset="0px" 
                data-lg-stick-up="true" 
                data-xl-stick-up="true" 
                data-xxl-stick-up="true"
            >
                <div className="rd-navbar-main">
                    <div className="rd-navbar-panel">
                        <button 
                            className="rd-navbar-toggle" 
                            data-rd-navbar-toggle=".rd-navbar-nav-wrap"
                        >
                            <span></span>
                        </button>
                        <div className="rd-navbar-brand">
                            <Link 
                                className="brand" 
                                to="/"
                            >
<picture>
  <source srcSet="/s/img/WTSLogoWithText_200_25.png" media="(max-width: 400px)"/>
  <source srcSet="/s/img/WTSLogoWithText_400_50.png" media="(max-width: 800px)"/>
  <source srcSet="/s/img/WTSLogoWithText_medium.png" media="(min-width: 801px)"/>
  <img className="brand-logologo-dark" src="/s/img/WTSLogoWithText_medium.png" width="1024" height="128" style={{width:'auto'}}/>
</picture> 
                            </Link>
                        </div>
                    </div>
                    <div className="rd-navbar-nav-wrap">
                        <ul className="rd-navbar-nav">
                      
                            <li ref ={productsSubmenu} className="rd-nav-item">
                                <Link
                                    to="#"
                                    className="rd-nav-link" 
                                    title="Products" 
                                >
                                    Products
                                </Link>    
                                <div className="rd-menu rd-navbar-megamenu">
                                <ul className="rd-navbar-megamenu-inner">
                                    <li className="rd-megamenu-item">
                                        <ul className="rd-megamenu-list">
                                            <li className="rd-megamenu-list-item"><b>Leads Generation</b></li>
                                            {/**
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/dashboard" onClick={handleSubmenuLinkClick}>Dashboard</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/lead-monitoring" onClick={handleSubmenuLinkClick}>Leads Monitoring</Link></li>
                                             */}
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/technology-type" onClick={handleSubmenuLinkClick}>Technologies</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/monitoring" onClick={handleSubmenuLinkClick}>Monitoring</Link></li>
                                        </ul>
                                    </li>
                                    <li className="rd-megamenu-item">
                                        <ul className="rd-megamenu-list">
                                            <li className="rd-megamenu-list-item"><b className="rd-megamenu-list-link">Security</b></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/security" onClick={handleSubmenuLinkClick}>Vulnerability Scanning</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/monitoring" onClick={handleSubmenuLinkClick}>Continious Monitoring</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/cve" onClick={handleSubmenuLinkClick}>CVE Vulnerability Database</Link></li>
                                        </ul>
                                    </li>
                                    <li className="rd-megamenu-item">
                                        <ul className="rd-megamenu-list">
                                            <li className="rd-megamenu-list-item"><b>Online Tools</b></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/technology-scan" onClick={handleSubmenuLinkClick}>Website Profiler</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/cve-security-scan" onClick={handleSubmenuLinkClick}>Security Scan</Link></li>
                                        </ul>
                                    </li>
                                    <li className="rd-megamenu-item">               
                                        <ul className="rd-megamenu-list">
                                            <li className="rd-megamenu-list-item"><b>Datasets</b></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/technology-type" onClick={handleSubmenuLinkClick}>Technologies</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/asn" onClick={handleSubmenuLinkClick}>ASN</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/ip-lookup" onClick={handleSubmenuLinkClick}>Reverse IP</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/tag" onClick={handleSubmenuLinkClick}>Tag Ids</Link></li>
                                            <li className="rd-megamenu-list-item"><Link className="rd-megamenu-list-link" to="/common-response-headers" onClick={handleSubmenuLinkClick}>HTTP Headers</Link></li>
                                        </ul>
                                    </li>                                                                                                                                                                                                                                                                                                     
                                </ul>
                                </div>
                            </li> 
{/** 
                            <li ref ={productsSubmenu} className="rd-nav-item">
                                <Link
                                    to="#"
                                    className="rd-nav-link" 
                                    title="Products" 
                                >
                                    Products
                                </Link>    
                                <ul className="rd-menu rd-navbar-dropdown">
                                    <li className="rd-dropdown-item">
                                        <Link
                                            to="/lead-list"
                                            className="rd-dropdown-link" 
                                            title="Technology Lookup" 
                                            onClick={handleSubmenuLinkClick}
                                        >
                                            Lead List Generation
                                        </Link>
                                    </li>                                                                                      
                                    <li className="rd-dropdown-item">
                                        <Link 
                                            to="/technology-type"
                                            className="rd-dropdown-link" 
                                            title="Web Technologies" 
                                            onClick={handleSubmenuLinkClick}
                                        >
                                            Web Technologies
                                        </Link>
                                    </li>
                                
                                    <li className="rd-dropdown-item">
                                        <Link 
                                            to="/website-lookup"
                                            className="rd-dropdown-link" 
                                            title="WebSite Technology Lookup"
                                            onClick={handleSubmenuLinkClick} 
                                        >
                                            WebSite Lookup
                                        </Link>
                                    </li>                                   

                                    
                                    <li className="rd-dropdown-item">
                                        <Link 
                                            to="/advertisers"
                                            className="rd-dropdown-link" 
                                            title="Advertisers"
                                            onClick={handleSubmenuLinkClick}
                                        >
                                            Advertisers
                                        </Link>
                                    </li>


                                    <li className="rd-dropdown-item">
                                        <Link 
                                            to="/asn"
                                            className="rd-dropdown-link" 
                                            title="ASN lookup" 
                                            onClick={handleSubmenuLinkClick}
                                        >
                                            ASNs
                                        </Link>
                                    </li>     

                                    <li className="rd-dropdown-item">
                                        <Link 
                                            to="/cve"
                                            className="rd-dropdown-link" 
                                            title="CVE Lookup"
                                            onClick={handleSubmenuLinkClick}
                                        >
                                            CVEs
                                        </Link>
                                    </li>

                                     <li className="rd-dropdown-item">
                                        <Link 
                                            to="/cwe"
                                            className="rd-dropdown-link" 
                                            title="CWE Lookup" 
                                            onClick={handleSubmenuLinkClick}
                                        >
                                            CWEs
                                        </Link>
                                    </li>
                                
                                     <li className="rd-dropdown-item">
                                        <Link 
                                            to="/ip-lookup"
                                            className="rd-dropdown-link" 
                                            title="Discover domain hosted on IP" 
                                            onClick={handleSubmenuLinkClick}
                                        >
                                            Reverse IP
                                        </Link>
                                    </li>

                                    <li className="rd-dropdown-item">
                                        <Link
                                            to="/tag"
                                            className="rd-dropdown-link" 
                                            title="TAG ID search" 
                                            onClick={handleSubmenuLinkClick}
                                        >
                                            TAG IDs
                                        </Link>
                                    </li>
                                    <li className="rd-dropdown-item">
                                        <Link 
                                            to="/common-response-headers"
                                            className="rd-dropdown-link" 
                                            title="HTTP Header search                                            "
                                            onClick={handleSubmenuLinkClick} 
                                        >
                                            HTTP Headers
                                        </Link>
                                    </li>
 
                                    <li></li>                                                                                                                                                                                                                          
                                </ul>
                            </li> 
 */}                   
                            <li className="rd-nav-item">
                                <Link 
                                    to="/pricing"
                                    className="rd-nav-link" 
                                    title="Pricing" 
                                >
                                    Pricing
                                </Link>
                            </li>   
                            <li className="rd-nav-item">
                                <Link 
                                    target="_blank" 
                                    to="/about-api"
                                    className="rd-nav-link" 
                                    title="API" 
                                >
                                    API
                                </Link>
                            </li>
                   
{/** 
                            <li className="rd-nav-item">
                                <a
                                    href="#"
                                    className="rd-nav-link" 
                                    title="Resources" 
                                >
                                    Resources
                                </a>    
                                <ul className="rd-menu rd-navbar-dropdown">                   
                                    <li className="rd-dropdown-item">
                                        <Link 
                                            target="_blank" 
                                            to="/about-api"
                                            className="rd-nav-link" 
                                            title="API" 
                                        >
                                            API
                                        </Link>
                                    </li>

                                    <li className="rd-dropdown-item">
                                        <Link 
                                            to="/faq"
                                            className="rd-nav-link" 
                                            title="FAQ" 
                                        >
                                            FAQ
                                        </Link>
                                    </li>
                                </ul>
                            </li> 
*/}                            
                            {
                                currentUser ?
                                <>
                                    <li className="rd-nav-item">
                                        <Link 
                                            to="/user/account"
                                            className="rd-nav-link" 
                                            title="User Account" 
                                        >
                                            Account
                                        </Link>
                                        <ul className="rd-menu rd-navbar-dropdown">
                                            <li className="rd-dropdown-item">
                                                <a 
                                                    href="/user/account"
                                                    className="rd-dropdown-link" 
                                                    title="User Account" 
                                                >
                                                    Account
                                                </a>
                                            </li>                                            
                                            <li className="rd-dropdown-item">
                                                <a 
                                                    href="/monitoring/websites"
                                                    className="rd-dropdown-link" 
                                                    title="Monitoring" 
                                                >
                                                    Monitored Websites
                                                </a>
                                            </li>
                                            <li className="rd-dropdown-item">
                                                <a 
                                                    href=""
                                                    className="rd-dropdown-link" 
                                                    title="Logout" 
                                                    onClick={handleLogout}
                                                >
                                                    Log Out
                                                </a>
                                            </li>
                                        </ul>
                                    </li>   
                                    {/* 
                                    <li className="rd-nav-item">
                                        <Link 
                                            className="button button-secondary" 
                                            title="Schedule a product demo" 
                                            to="/schedule-demo"
                                        >
                                            Schedule Demo
                                        </Link>
                                    </li>                            
                                    */}                                    
                                    <li className="rd-nav-item">
                                        <Link 
                                            className="button button-secondary" 
                                            title="Free Security Scan for Known Vulnerabilities" 
                                            to="/cve-security-scan"
                                        >
                                            Free Security Scan
                                        </Link>
                                    </li>                            

                                </>
                                :
                                <>
                                    <li className="rd-nav-item">
                                        <a 
                                            //to="#"
                                            className="rd-nav-link"
                                            style={{cursor: 'pointer'}} 
                                            title="Sign In" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                 setLoginType((<Login />))
                                            }}
                                        >
                                            Sign In
                                        </a>
                                    </li>
                                    <li className="rd-nav-item">                                      
                                        <a 
                                            href="#"
                                            className="rd-nav-link" 
                                            style={{color: 'red', cursor: 'pointer'}} 
                                            title="Sign Up to see more results" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLoginType((<Register />))
                                            }}
                                        >
                                            Free Sign Up
                                        </a>                              
                                    </li>
                                    {/** 
                                    <li className="rd-nav-item">
                                        <Link 
                                            className="button button-secondary" 
                                            title="Schedule a product demo" 
                                            to="/schedule-demo"
                                        >
                                            Schedule Demo
                                        </Link>
                                    </li>*/}                                    
                                    <li className="rd-nav-item">
                                        <Link 
                                            className="button button-secondary" 
                                            title="Free Security Scan for Known Vulnerabilities" 
                                            to="/cve-security-scan"
                                        >
                                            Free Security Scan
                                        </Link>
                                    </li>
                                </>
                            }
                        </ul>
                        <form action="/search">
                            <div className="container justify-content-center align-items-center">
                                <div className="row">
                                        <div className="col">
                                            <input 
                                                style={{width:'300px'}} 
                                                className="form-input" 
                                                type="text" 
                                                title="Type the technology or domain name without any special characters or quotation marks" 
                                                placeholder="Lookup website or web technology" 
                                                name="q"
                                                required                                       
                                                pattern="[\-a-zA-Z0-9\s\/\.\(\):_&@\?=]+"
                                            >                                 
                                            </input>
                                        </div>
                                        <div className="col">
                                            <button 
                                                className="button button-primary" 
                                                title="Lookup website or web technology" 
                                                type="submit"
                                            >
                                                SEARCH
                                            </button>
                                        </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="rd-navbar-dummy"></div>
                </div>
            </nav>
        </div>
    </header>
    )
}